import { createBrowserRouter } from "react-router-dom";
import { Shell } from "@/ui/Shell";
import { Guard } from "./Guard";
import { SignIn } from "./SignIn";
import { Home } from "./Home";
import { NewChallenge } from "./NewChallenge";
import { JoinChallenge } from "./JoinChallenge";
import { Invite } from "./Invite";
import { Challenge } from "./Challenge";
import { Compose } from "./Compose";
import { Compartilhar } from "./Compartilhar";
import { Plate } from "./Plate";
import { Standings } from "./Standings";
import { Temporada } from "./Temporada";
import { Resumo } from "./Resumo";
import { Details } from "./Details";
import { Chat } from "./Chat";
import { Guide } from "./Guide";
import { Recap } from "./Recap";
import { Profile } from "./Profile";
import { EditChallenge } from "./EditChallenge";
import { Rules } from "./Rules";
import { Missoes } from "./Missoes";
import { NovaMissao } from "./NovaMissao";
import { EditPlate } from "./EditPlate";
import { Account } from "./Account";
import { Assinar } from "./Assinar";
import { Privacidade } from "./Privacidade";
import { Sobre } from "./Sobre";
import { SegurancaInfantil } from "./SegurancaInfantil";
import { NotFound } from "./NotFound";

/**
 * Rotas de CAMINHO, não de hash.
 *
 * O app anterior usava `#/c/...` porque o GitHub Pages não faz rewrite de
 * SPA. Com o Firebase Hosting isso deixa de ser necessário — e deixa de ser
 * opcional: Universal Links no iOS só funcionam com caminho de verdade, e
 * sem eles o link de convite não abre o app no iPhone.
 *
 * `/convite/:code` fica FORA do Guard de propósito: quem recebe o convite
 * pode não ter conta ainda. O Guard interno manda para o login guardando o
 * destino, e a pessoa volta para o convite depois de entrar.
 */
export const router = createBrowserRouter([
  {
    path: "/",
    element: <Shell />,
    errorElement: <NotFound />,
    children: [
      { path: "entrar", element: <SignIn /> },
      /* Privacidade e Sobre ficam FORA do Guard: a loja exige que a URL da
         política abra sem login, e quem está decidindo se instala é
         exatamente quem ainda não tem conta. */
      { path: "privacidade", element: <Privacidade /> },
      { path: "sobre", element: <Sobre /> },
      { path: "seguranca-infantil", element: <SegurancaInfantil /> },
      {
        element: <Guard />,
        children: [
          { index: true, element: <Home /> },
          { path: "novo", element: <NewChallenge /> },
          { path: "entrar-codigo", element: <JoinChallenge /> },
          { path: "convite/:code", element: <JoinChallenge /> },
          { path: "conta", element: <Account /> },
          /* Onde o Android entrega a foto que veio de outro app. Fica
             DENTRO do Guard porque publicar exige conta — o Guard guarda
             o destino, e a foto espera no cache enquanto a pessoa entra.
             Ver `lib/compartilhado.ts`. */
          { path: "compartilhar", element: <Compartilhar /> },
          { path: "assinar", element: <Assinar /> },
          { path: "c/:cid", element: <Challenge /> },
          { path: "c/:cid/convite", element: <Invite /> },
          { path: "c/:cid/novo", element: <Compose /> },
          { path: "c/:cid/p/:pid", element: <Plate /> },
          { path: "c/:cid/p/:pid/editar", element: <EditPlate /> },
          { path: "c/:cid/classificacao", element: <Standings /> },
          { path: "c/:cid/temporada/:de", element: <Temporada /> },
          { path: "c/:cid/resumo/:periodo", element: <Resumo /> },
          { path: "c/:cid/detalhes", element: <Details /> },
          { path: "c/:cid/bate-papo", element: <Chat /> },
          { path: "c/:cid/guia", element: <Guide /> },
          { path: "c/:cid/recap", element: <Recap /> },
          { path: "c/:cid/u/:uid", element: <Profile /> },
          { path: "c/:cid/editar", element: <EditChallenge /> },
          { path: "c/:cid/regras", element: <Rules /> },
          { path: "c/:cid/missoes", element: <Missoes /> },
          { path: "c/:cid/missoes/nova", element: <NovaMissao /> },
        ],
      },
      { path: "*", element: <NotFound /> },
    ],
  },
]);
